<form class="k-form" [formGroup]="form">

  <fieldset>

    <div class="row">
      <label  class="col-3 col-form-label">Opportunity</label>
      <div class=" col-9">
        <kendo-dropdownlist  formControlName="opportunity_id"
                            [data]="opportunityList" [defaultItem]="defaultItem" textField="title" valueField="id"
                            [valuePrimitive]="true" required>
        </kendo-dropdownlist>
        <br>

        <div *ngIf="opportunity_id?.invalid" class="alert alert-danger">
          <div *ngIf="opportunity_id?.errors?.['required']">Opportunity is required.</div>
        </div>
      </div>

    </div>


    <!-- Buttons -->

    <div class="d-grid d-md-flex justify-content-md-end mt-4">
      <button type="button" class="btn btn-primary me-md-2" (click)="onSubmit()" [disabled]="form.invalid">Save</button>
      <button type="button" class="btn btn-secondary" (click)="closeWindow()"> Cancel</button>
    </div>

  </fieldset>
</form>


